import script from "./UserRecentQueriesContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserRecentQueriesContainer.vue?vue&type=script&lang=ts&setup=true"

import "./UserRecentQueriesContainer.vue?vue&type=style&index=0&id=46d56ab6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46d56ab6"]])

export default __exports__